/** @jsx h */
import { h, Component } from 'preact'
import * as analytics from '../../../utils/analytics'
import ProofPoint from './ProofPoint'

export default class ClaimCardPJ extends Component {
  handleClick = () => {
    this.props.populateDrawer(this.props)
    this.track()
  }

  track () {
    const { name, type } = this.props

    analytics.track('Story Proof Point Clicked', {
      eventCategory: type,
      eventAction: name,
      eventLabel: window.location.href
    })
    analytics.track('proofpoint_clicked', {
      object: 'proofpoint',
      action: 'clicked',
      context: 'story',
      type,
      name,
      event_label: window.location.href
    }, { adapter: 'segment' })
  }

  render () {
    return (
      <button class='ClaimCard--journey' onClick={this.handleClick} type='button'>
        <ProofPoint {...this.props} />
      </button>
    )
  }
}
